"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageAssignmentShim = void 0;
// noinspection JSUnusedGlobalSymbols (methods are used by common repository)
const configuration_factory_1 = require("../configuration-factory");
class LocalStorageAssignmentShim {
    constructor(storageKeySuffix) {
        this.size = this.getCache().size;
        this[_a] = this.getCache()[Symbol.toStringTag];
        if (!(0, configuration_factory_1.hasWindowLocalStorage)()) {
            throw new Error('LocalStorage is not available');
        }
        const keySuffix = storageKeySuffix ? `-${storageKeySuffix}` : '';
        this.localStorageKey = `eppo-assignment${keySuffix}`;
    }
    clear() {
        this.getCache().clear();
    }
    delete(key) {
        return this.getCache().delete(key);
    }
    forEach(callbackfn, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    thisArg) {
        this.getCache().forEach(callbackfn, thisArg);
    }
    entries() {
        return this.getCache().entries();
    }
    keys() {
        return this.getCache().keys();
    }
    values() {
        return this.getCache().values();
    }
    [Symbol.iterator]() {
        return this.getCache()[Symbol.iterator]();
    }
    has(key) {
        return this.getCache().has(key);
    }
    get(key) {
        var _b;
        return (_b = this.getCache().get(key)) !== null && _b !== void 0 ? _b : undefined;
    }
    set(key, value) {
        return this.setCache(this.getCache().set(key, value));
    }
    getCache() {
        const cache = window.localStorage.getItem(this.localStorageKey);
        return cache ? new Map(JSON.parse(cache)) : new Map();
    }
    setCache(cache) {
        window.localStorage.setItem(this.localStorageKey, JSON.stringify(Array.from(cache.entries())));
        return this;
    }
}
exports.LocalStorageAssignmentShim = LocalStorageAssignmentShim;
_a = Symbol.toStringTag;
//# sourceMappingURL=local-storage-assignment-shim.js.map